import { Component, OnInit } from '@angular/core';
import { buildInfo } from '../../../../../environments/build-info';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-aside-menu',
  templateUrl: './aside-menu.component.html',
  styleUrls: ['./aside-menu.component.scss'],
})
export class AsideMenuComponent implements OnInit {
  appAngularVersion: string = environment.appVersion;
  appPreviewChangelogUrl: string = environment.appPreviewChangelogUrl;
  buildCommit: string = buildInfo.commit;
  buildTime: string = buildInfo.buildTime;

  constructor() {}

  ngOnInit(): void {}
}
